import { OnBaseDocumentData } from '../types/OnBaseDocumentData';
import { EventHandler, MouseEventHandler, useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from "primereact/button";
import ViewOnBaseDocumentModal from './ViewOnBaseDocumentModal';
import useGetOnBaseDocuments from '../hooks/useGetOnBaseDocuments';
import { GetOnBaseDocumentsRequest } from '../types/GetOnBaseDocumentsRequest';
import '../../../styles/dashboardStyles.css';

interface props {
  DataList: OnBaseDocumentData[],
  handleRequeueDocument: any,
  handleDeleteDocument: any,
  handleDownloadDocument: any
}

function OnBaseDocumentsTable({ DataList, handleRequeueDocument, handleDeleteDocument, handleDownloadDocument }: props) {

  const formatted_data = DataList?.map(item => ({
    ...item,
    memberFullName: item.firstName + ' ' + item.lastName,
  }));

  const [ShowModal, setShowModal] = useState<boolean>(false);
  const handleClose = () => { setShowModal(false) };
  const [currentRowKey, setcurrentRowKey] = useState("");

  function Requeue(doc: OnBaseDocumentData) {
    handleRequeueDocument(doc);
  }

  function Delete(doc: OnBaseDocumentData) {
    handleDeleteDocument(doc);
  }

  function Download(doc: OnBaseDocumentData) {
    handleDownloadDocument(doc);
  }

  const ButtonsTemplate = (rowData: OnBaseDocumentData, column: any) => {
    return (<div>
      <Button className='small-pr-button'  severity='info'  onClick={() => ViewMetaDataClick(rowData)}>View</Button>
      <Button className='small-pr-button'  severity='success'  onClick={() => ReSendClick(rowData)}>Re-Send</Button>
      <Button className='small-pr-button'  severity='secondary'  onClick={() => DownloadClick(rowData)}>Download</Button>
      <Button className='small-pr-button'  severity='danger'  onClick={() => RemoveClick(rowData)}>Remove</Button>
    </div>)
  };

  const ViewMetaDataClick = (rowData: OnBaseDocumentData) => {
    setcurrentRowKey(() => { return rowData.rowKey; })
    setShowModal(() => { return true });
  }

  const ReSendClick = (rowData: OnBaseDocumentData) => {
    Requeue(rowData)
  }

  const RemoveClick = (rowData: OnBaseDocumentData) => {
    if (confirm(`Are you sure you want to DELETE document ${rowData.documentName}?`))
      Delete(rowData)
  }

  const DownloadClick = (rowData: OnBaseDocumentData) => {
    Download(rowData)
  }

  return (
    <>

      <div className="data-table-section p-grid">
        <DataTable value={formatted_data} stripedRows >
          <Column field='rowKey' header='RowKey' style={{ display: 'none' }}></Column>
          <Column field='partitionKey' header='PartitionKey' style={{ display: 'none' }}></Column>
          <Column field='blobUrl' header='BlobUrl' style={{ display: 'none' }}></Column>
          <Column field='documentTypeId' header='DocumentTypeId' style={{ display: 'none' }}></Column>
          <Column field='documentName' header='Document Name' ></Column>
          <Column field='onBaseDocumentTypeName' header='Doc Type' ></Column>
          <Column field='memberFullName' header='Member'></Column>
          <Column field='benesysAltId' header='Member ID' ></Column>
          <Column field='client' header='Client' ></Column>
          <Column field='onBaseAttemptNumber' header='Attempts' ></Column>
          <Column field='supportNotificationSent' header='Support' ></Column>
          <Column field="ButtonsTemplate" header="Actions" style={{ width: "23em" }} body={ButtonsTemplate} />
        </DataTable>
      </div>
      {ShowModal && (
        <ViewOnBaseDocumentModal handleClose={handleClose} RowKey={currentRowKey} />
      )
      }

    </>
  )
}

export default OnBaseDocumentsTable;